import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import { applyAuthTokenInterceptor, clearAuthTokens } from 'axios-jwt'

const config = {
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Accept-Language': process.env.VUE_APP_LANGUAGE || 'us'
  }
}
const axiosInstance = axios.create(config)
const createNotify = (title, type = 'error') => {
  Vue.notify({ type, title })
}
const user_roles = JSON.parse(localStorage.getItem('userGroups'))

axiosInstance.interceptors.response.use(undefined, function (err) {
  // if (!err.status) throw err
  return new Promise(function () {
    if (err.response.status === 500) {
      createNotify('A critical error has occurred, contact your administrator')
      throw err
    }
    if (err.response.status === 401) {
      clearAuthTokens()
      localStorage.clear()
      router.push({ name: 'login' }).catch(() => {})
    }
    if (err.response.status === 404) {
      createNotify('You dont have access to this page')
      router.push({ name: user_roles[0].index_page }).catch(() => {})
    }
    for (const key in err.response.data) {
      const error = err.response.data[key]
      if (Array.isArray(error)) {
        createNotify(error[0])
      } else {
        createNotify(error)
      }
    }
    throw err
  })
})

const requestRefresh = (refresh) => {
  return new Promise((resolve, reject) => {
    axios.post(`${config.baseURL}auth/jwt/refresh/`, { refresh }).then(response => {
      resolve({
        accessToken: response.data.access,
        refreshToken: response.data.refresh
      })
    }).catch(error => {
      if (error.response.status === 401) {
        createNotify('Unauthorized', 'warning')
        router.push({ name: 'login' }).catch(() => {})
      }
      reject(error)
    })
  })
}

applyAuthTokenInterceptor(axiosInstance, { requestRefresh })

export default axiosInstance